import { EsimPackage, EsimPackageGroup } from "@/lib/redux/features/esim/types";

export const groupEsimPackages = (packages: EsimPackage[]): EsimPackageGroup[] => {
  const map = new Map<string, EsimPackageGroup>();

  for (const pkg of packages) {
    const id = pkg.parentGroupId || pkg.gggPlanId;
    const name = pkg.parentGroupName || pkg.gggPlanId;
    const existing = map.get(id);

    if (existing) {
      existing.packages.push(pkg);
      continue;
    }

    map.set(id, { id, name, packages: [pkg] });
  }

  return Array.from(map.values());
};
